/* template */
<template><div :data-mall-theme="(theme)" :style="(headerStyle)" class="header-wrap"><div class="header-title-wrap" v-if="(!hideTitle)"><div class="header-title">{{mallData.title}}</div><div class="header-desc" v-if="(!hideSubTitle && subTitle)"><special-text :text="(subTitle)" :rules="(hightLghtRules)" class="desc-text"></special-text></div></div><soldout-logo :soldOutType="(mallData.soldOutType)" class="sold-out-icon" v-if="(mallData.soldOut && mallData.currentPage !== 'goodsProcess')"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mfc854284"}'>
@import "../../../lib/stylus/variable.styl"
@import './theme.styl'
.header-wrap
  width 750rpx
  height 300rpx
  font-weight: $fw-semi-bold;
  position relative
  .header-title-wrap
    position absolute
    left 40rpx;
    top 62rpx;
    .header-title
      font-size: 54rpx;
      font-weight: $fw-semi-bold;
      color: #FFFFFF;
      letter-spacing: 0;
      line-height: 64rpx;
      text-shadow: 0 2rpx 30rpx rgba(0,0,0,0.11);
    .header-desc
      margin-top 14rpx
      border-radius: 14rpx;
      font-size: 28.62rpx;
      color: #FFFFFF;
      letter-spacing: 0;
      text-shadow: 0 2rpx 32rpx rgba(0,0,0,0.11);
      font-weight: $fw-regular;
    .desc-text
      display flex
      align-items flex-end
      line-height 29rpx
      white-space pre
  .sold-out-icon
    position absolute
    top -14rpx
    right 0rpx

theme()
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { ComponentsMixin } from '../../../lib/webx/mpx/mixins/page_detail/component'
import { EnumGoodsType, EnumLang, EnumSoldOutType } from '../../../lib/webx/defines/enums.js'
import { GlobalEnv } from '../../../lib/webx/global_env/index.js'
import { utils } from '@didi/webx-js'
import { rpx } from '../../../lib/webx/utils/format'
import { getCurrencyText } from '../../../lib/js/util'

createComponent({
  mixins: [ ComponentsMixin ],
  data: {
    EnumSoldOutType,
    hightLghtRules: {
      '{x}': {
        style: Object.entries({
          'color': '#FFFFFF',
          'font-family': 'Barlow-ExtraBoldItalic',
          'font-size': rpx('32.91rpx'),
          'margin-bottom': rpx('2rpx'),
        }).map(([ key, value ]) => `${key}: ${value}`).join(';'),
      },
    },
  },
  computed: {
    headerStyle() {
      return {
        'background-image': `url(${utils.webpUrl(this.mallData.backgroundImage || 'https://dpubstatic.udache.com/static/dpubimg/30d39875-2ff7-4484-9e79-e038a4eea4a1.png')})`,
        'background-repeat': 'no-repeat',
        'background-size': '100% 100%',
      }
    },
    hideTitle() {
      return this.mallData?.hideTitle
    },
    hideSubTitle() {
      return this.mallData.goodsType === EnumGoodsType.Finance
    },
    isEn() {
      return GlobalEnv.lang === EnumLang['en-US']
    },
    // 单位
    currencyText() {
      return getCurrencyText(this.mallData.currency)
    },
    subTitle() {
      if (this.mallData.goodsType === EnumGoodsType.Economic) {
        return ''
      }
      const desc1 = this.mallData.couponNumber ? this.$t('goodsDetail.totalCouponNumber', { count: `{${this.mallData.couponNumber}}` }) : ''
      const desc2 = this.mallData.totalSave ? this.$t('goodsDetail.totalMaxSaveText', { total_save: `{${this.mallData.totalSave}}${this.currencyText}` }) : ''
      return `${desc1} ${desc2}`
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "indexfc854284",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'special-text':getComponent(require("../../../../node_modules/@didi/mpx-ui/src/components/special-text/index.mpx?component=true&componentId=index8d2b07c0")),'soldout-logo':getComponent(require("./soldout-logo.mpx?component=true&componentId=soldout-logo3eb8d8a0"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
